/**
 * 枚舉
 * SweetAlert
 * @author J
 * @since 2024-04-30 07:34:25
 */

/**
 * 類型
 */
export const SweetAlertEnum = Object.freeze({

    /**
     * 顯示
     */
    SUCCESS: 0,

    /**
     * 警告
     */
    WARNING: 1,

    /**
     * 警告 - 單按鈕
     */
    WARNING_ONE: 2,

    /**
     * 詢問
     */
    QUESTION: 3,

})

/**
 * 圖示
 */
export const SweetAlertIconEnum = Object.freeze({

    /**
     * 不顯示
     */
    NONE: "",

    /**
     * 成功
     */
    SUCCESS: "success",

    /**
     * 警告
     * handler
     */
    WARNING: "warning",

    /**
     * 提問
     * handler
     */
    QUESTION: "question",

})